import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from "react-query";

import {
  addEmployeesGroup,
  assignAccess,
  deleteAccess,
  editEmployeesGroup,
  getEmployeesAccess,
} from "./index";

const useOnSuccess = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["get-employees-groups"] });
  };
};

export const useGetEmployeesAccess = (
  config?: Omit<
    UseQueryOptions<any, any, any, string[]>,
    "queryKey" | "queryFn"
  >
) => {
  // @ts-ignore
  return useQuery(["get-employees-access"], getEmployeesAccess, config);
};

export const useAddEmployeesGroup = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["add-employees-group"], addEmployeesGroup, {
    onSuccess,
  });
};

export const useEditEmployeesGroup = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["edit-employees-group"], editEmployeesGroup, {
    onSuccess,
  });
};

export const useAssignAccess = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["assign-access"], assignAccess, {
    onSuccess,
  });
};

export const useDeleteAccess = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["delete-access"], deleteAccess, {
    onSuccess,
  });
};
